import type { SelectOption } from '@aus-platform/design-system';
import {
  BaseReference,
  HeapCategory,
  HeapMaterialType,
} from '../../../../../shared/api';
import { Formatter } from '../../../../../shared/helpers';

export const heapTabs = {
  Draw: 'Draw',
  List: 'List',
  Guide: 'Guide',
};

export const baseReferenceLabel = {
  [BaseReference.VisibleGround]: 'Visible Ground',
  [BaseReference.OtherIterationDsm]: 'Other Iteration DEM',
  [BaseReference.SiteBaseDsm]: 'Site Base DEM',
};

export const materialTypeLabels: Record<HeapMaterialType, string> = {
  [HeapMaterialType.Ore]: 'Ore',
  [HeapMaterialType.Overburden]: 'Overburden',
  [HeapMaterialType.Other]: 'Other',
  [HeapMaterialType.OreAndOverburden]: 'Ore + OB',
};

export const materialTypeOptions: SelectOption<HeapMaterialType>[] = (
  Object.keys(materialTypeLabels) as HeapMaterialType[]
).map((value) => ({ label: materialTypeLabels[value], value }));

export const getMaterialTypeLabel = (value: string): string =>
  materialTypeLabels[value] ?? Formatter.toTitleCase(value);

export const volumeCategoryOptions: SelectOption<HeapCategory>[] = [
  {
    label: Formatter.toTitleCase(HeapCategory.ExcavatedVolume, '_'),
    value: HeapCategory.ExcavatedVolume,
  },
  {
    label: Formatter.toTitleCase(HeapCategory.IncrementalDumpVolume, '_'),
    value: HeapCategory.IncrementalDumpVolume,
  },
  {
    label: Formatter.toTitleCase(HeapCategory.StockVolume, '_'),
    value: HeapCategory.StockVolume,
  },
  {
    label: Formatter.toTitleCase(HeapCategory.Other, '_'),
    value: HeapCategory.Other,
  },
];

export const HEAP_MARK_AREA_PROPERTY_KEY = 'MarkArea';
